import { useEffect, useState } from 'react';
import useAsyncFn from 'react-use/lib/useAsyncFn';

const ONBOARDING_BASE_URL = 'https://onboarding.confidence.dev/v1';

type RegionCheckResult = {
  allowed: boolean;
};

/**
 * Calls the onboarding API to validate available regions.
 */
export const useRegionCheck = () => {
  const [regionData, setRegionData] = useState<RegionCheckResult | null>(null);

  const [{ loading, error }, checkRegion] = useAsyncFn(async () => {
    const response = await fetch(`${ONBOARDING_BASE_URL}/country:validate`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to validate region: ${response.statusText}`);
    }

    const data: RegionCheckResult = await response.json();

    setRegionData(data);
    return data;
  }, []);

  useEffect(() => {
    checkRegion();
  }, [checkRegion]);

  return {
    loading,
    error,
    regionData,
  };
};
